var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Pin = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 843.75 1022.61", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M421.64 670.61a256 256 0 1 1 181-75 254.32 254.32 0 0 1-181 75zm0-448c-105.87 0-192 86.13-192 192s86.13 192 192 192 192-86.14 192-192-86.13-192-192-192z" }),
            React.createElement("path", { className: "cls-1", d: "M422.59 1022.61a31.91 31.91 0 0 1-23.29-10.05L114.87 710.9a421.64 421.64 0 0 1 604.92-587.4l.45.45a421.63 421.63 0 0 1 9.14 586.88L506 948.52a32 32 0 1 1-46.64-43.83L682.74 667A357.66 357.66 0 0 0 675 169.21l-.46-.45A357.64 357.64 0 0 0 161.43 667l284.44 301.65a32 32 0 0 1-23.28 54z" }))))); };
export default Pin;
//# sourceMappingURL=Pin.js.map